import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SimplebarAngularModule } from 'simplebar-angular';
import { BurgerButtonWrapperComponent } from '../../../burger-button-wrapper/burger-button-wrapper.component';
import { TagChipAutocompleteModule } from '../../../components/templates/tag-chip-autocomplete/tag-chip-autocomplete.module';
import { DaveDoubleIconModule } from "../../../dave-double-icon/dave-double-icon.module";
import { DaveEventListEntryModule } from '../../../dave-event-list-entry/dave-event-list-entry.module';
import { DaveFullscreenDialogModule } from "../../../dave-fullscreen-dialog/dave-fullscreen-dialog.module";
import { DaveLoadingModule } from '../../../dave-loading/dave-loading.module';
import { AppButtonModule } from '../../../dave-utils-module/app-button-module/app-button.module';
import { DaveSharedComponentsModule } from '../../../dave-utils-module/dave-shared-components-module/dave-shared-components.module';
import { PipesModule } from '../../../dave-utils-module/dave-shared-components-module/pipes/pipes.module';
import { IconPipeModule } from '../../../dave-utils-module/icon-pipe/icon-pipe.module';
import { SelectSearchModule } from '../../../dave-utils-module/select-search/select-search.module';
import {
DocumentDetectionResultDataModalComponent
} from "../../../document-detection-result-data-modal/document-detection-result-data-modal.component";
import { EditDocumentUserComponent } from '../edit-document-user/edit-document-user.component';
import { PdfEditorLegacyModule } from '../pdf-editor-legacy/pdf-editor-legacy.module';
import { PreviewComponent } from './preview.component';
import { DaveEventCardModule } from '../../../dave-event-card/dave-event-card.module';

@NgModule({
    declarations: [PreviewComponent, EditDocumentUserComponent],
    imports: [
        CommonModule,
        TagChipAutocompleteModule,
        RouterModule,
        PipesModule,
        DaveSharedComponentsModule,
        FontAwesomeModule,
        AppButtonModule,
        MatTooltipModule,
        SimplebarAngularModule,
        MatChipsModule,
        MatButtonModule,
        IconPipeModule,
        PdfEditorLegacyModule,
        MatTabsModule,
        MatTableModule,
        DaveLoadingModule,
        DaveFullscreenDialogModule,
        MatDialogModule,
        SelectSearchModule,
        MatCheckboxModule,
        BurgerButtonWrapperComponent,
        DaveEventListEntryModule,
        MatMenuModule,
        DocumentDetectionResultDataModalComponent,
        DaveDoubleIconModule,
        DaveEventCardModule,
    ],
    exports: [PreviewComponent],
})
export class PreviewModule {}
